"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCenterRoot = exports.NotificationCenter = exports.trackingIds = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const ContextProviders_1 = require("../../../components/Elements/ContextProviders");
const useAnalytics_1 = require("../../../hooks/useAnalytics");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const models_1 = require("../../../models");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const translations_1 = require("../types/translations");
const Notifications_1 = require("./Notifications");
exports.testIds = {
    settingsButton: 'notification_center-settings-trigger_button',
};
exports.trackingIds = {
    settingsButton: 'notification_center-settings-trigger_button',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    wrapper: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: theme.palette.background.paper,
    },
    header: {
        padding: theme.spacing(2.5),
    },
}));
const NotificationCenter = () => {
    const classes = useStyles();
    const { state: { user }, } = (0, frontend_infra_auth_1.useAuth)();
    const history = (0, react_router_dom_1.useHistory)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const analytics = (0, useAnalytics_1.useAnalytics)();
    (0, react_1.useEffect)(() => {
        const userID = user?._id;
        if (userID) {
            const localStorageKey = `notification_center-visited-${userID}`;
            const isUserVisitedNC = localStorage.getItem(localStorageKey);
            if (!isUserVisitedNC) {
                localStorage.setItem(localStorageKey, 'true');
                analytics.sendEvent('notification-center-visited', { userID });
            }
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { className: classes.wrapper, children: [(0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.header, justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "h5", children: translate(translations_1.notificationCenterTranslations.title) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { onClick: () => history.push(models_1.notificationSettingsRoute), color: "primary", startIcon: (0, jsx_runtime_1.jsx)(silhouette_core_1.SettingsRoundedIcon, {}), "data-tracking-id": exports.trackingIds.settingsButton, "data-testid": exports.testIds.settingsButton, children: translate(translations_1.notificationCenterTranslations.settingsButton) }) })] }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Divider, {}), (0, jsx_runtime_1.jsx)(useNotificationListState_1.NotificationListContextProvider, { children: (0, jsx_runtime_1.jsx)(Notifications_1.Notifications, {}) })] }));
};
exports.NotificationCenter = NotificationCenter;
const NotificationCenterRoot = ({ config }) => {
    return ((0, jsx_runtime_1.jsx)(ContextProviders_1.ContextProviders, { children: (0, jsx_runtime_1.jsx)(ConfigContext_1.ConfigContextProvider, { config: config, children: (0, jsx_runtime_1.jsx)(LoggerContext_1.LoggerContextProvider, { children: (0, jsx_runtime_1.jsx)(exports.NotificationCenter, {}) }) }) }));
};
exports.NotificationCenterRoot = NotificationCenterRoot;
//# sourceMappingURL=NotificationCenterRoot.js.map